import { Component, OnInit, Input } from '@angular/core';

import { DriverIdentificationData } from '../../models/driver-identification.model';
import { DriverIdentificationService } from '../../services/driver-identification.service';

@Component({
  selector: 'app-driver-selection-item',
  templateUrl: './driver-selection-item.component.html',
  styleUrls: ['./driver-selection-item.component.scss']
})
export class DriverSelectionItemComponent implements OnInit {

  @Input() driver! : DriverIdentificationData;
  @Input() currentFilter: string | null = 'all';
  @Input() activeFullScreeenFn!: (driverId? : string) => void

  public driverIdSelected$ = this.driverIdentificationService.driverId$;
  constructor(
    private driverIdentificationService: DriverIdentificationService
  ) { }

  ngOnInit(): void {
  }

  get displayDate(): string {
    if (this.currentFilter === 'evaluated') {
      return this.driver?.lastSeen && this.driver.lastSeen !== '-' ? this.driver.lastSeen : '';
    }
    return this.driver?.checklistDate && this.driver.checklistDate !== '-' ? this.driver.checklistDate : '';
  }



  private clickTimeout: any;
  private clickDelay = 180; // ms

  public onClick() {
    if (this.clickTimeout) {
      // 👉 doble click
      clearTimeout(this.clickTimeout);
      this.clickTimeout = null;
      this.onDoubleClick();
    } else {
      // 👉 posible click simple
      this.clickTimeout = setTimeout(() => {
        this.onSingleClick();
        this.clickTimeout = null;
      }, this.clickDelay);
    }
  }

  private onSingleClick() {
    this.driverIdentificationService.selectDriver(this.driver);
  }

  private onDoubleClick() {
    console.log('DOBLE CLICK 🚀');
    this.activeFullScreeenFn(this.driver.id);
    // this.driverIdentificationService.selectDriver(this.driver);
  }
}
